import { useGetStandardsQuery } from "../../redux/apiSlice";
import { useStateSelector } from "../EditorState";
import { selectProjectName } from "../EditorState/selectors";

export default function useProjectName(): string | null {
	const { data: standardsData } = useGetStandardsQuery();
	return useStateSelector(selectProjectName(standardsData));
}
